<template>
  <div>
    <v-layout row wrap align-start>
      <v-flex v-if="bookingForm.booking.card_payment_type == 'prepaid'" xs12 px-2>
        <v-alert dense color="red" border="top">
          <p>
            This trip has been
            <b>prepaid</b>. Changing booking parameters will not affect final cost.
          </p>
        </v-alert>
      </v-flex>
      <v-flex px-1 pt-1 xs6 sm2>
        <SelectablePaymentTypeInput
          @input="changePaymentType"
          :paymentType="bookingForm.booking.payment_type"
          :paymentTypes="bookingForm.paymentTypes()"
          :user="bookingForm.user"
          label="Payment Type"
          :error="bookingForm.errors.payment_type"
        />
      </v-flex>
      <v-flex pl-1 pt-1 shrink :class="{'disabled-panel': bookingIsCompletedOrCancelled}">
        <v-row>
          <v-flex shrink>
            <SelectableCardInput
              @input="changePaymentTypeToCard"
              :cards="bookingForm.user.cards"
              :card="bookingForm.booking.card"
              :enabled="bookingForm.booking.payment_type == 'card'"
              label="Cards"
              :error="bookingForm.errors.card"
            />
          </v-flex>
          <div class="small-fab" v-if="!bookingIsCompletedOrCancelled">
            <v-layout row align-center>
              <v-btn
                icon
                v-if="bookingForm.user.contact_number.length > 0"
                @click="addingCard = true"
              >
                <v-icon>payment</v-icon>
              </v-btn>
            </v-layout>
          </div>
        </v-row>
      </v-flex>
      <v-flex shrink pt-1 pr-1 :class="{'disabled-panel': bookingIsCompletedOrCancelled}">
        <v-layout row>
          <v-flex shrink>
            <SelectablePromocodeInput
              :enabled="bookingForm.booking.payment_type == 'card'"
              @input="changePromocode"
              :promocode="bookingForm.booking.promocode"
              :promocodes="bookingForm.user.promocodes"
              :booking="bookingForm.booking"
              :bookingForm="bookingForm"
              label="Promo"
              :error="bookingForm.errors.promocode"
            />
          </v-flex>
          <div class="small-fab" v-if="!bookingIsCompletedOrCancelled">
            <v-layout row align-center>
              <v-btn
                icon
                v-if="bookingForm.user.contact_number.length > 0"
                @click="addingPromocode = true"
              >
                <v-icon>card_giftcard</v-icon>
              </v-btn>
            </v-layout>
          </div>
        </v-layout>
      </v-flex>
      <v-layout
        shrink
        ma-1
        mt-0
        pr-2
        pt-1
        row
        :class="{'change-cost-panel': bookingIsCompletedOrCancelled}"
        class="enabled-panel"
        v-if="!bookingIsCancelled"
      >
        <v-flex shrink>
          <div>
            <SimpleCurrencyInput
              @input="finalCostChanged"
              v-model="bookingForm.booking.final_cost"
              label="Final Cost"
              :error="bookingForm.errors.final_cost"
            />
            <p
              v-if="bookingForm.booking.final_cost_promotion != null && bookingForm.booking.final_cost_promotion != 0"
            >Final Cost Promotion: £{{bookingForm.booking.final_cost_promotion.toFixed(2)}}</p>
          </div>
        </v-flex>
        <v-flex shrink px-1>
          <div
            v-if="(bookingForm.booking.payment_type == 'card' || bookingForm.booking.payment_type == 'account') && bookingForm.booking.fixed_cost == true"
          >
            <SimpleCurrencyInput
              @input="finalCostDriverChanged"
              v-model="bookingForm.booking.final_cost_driver"
              label="Driver Cost"
              :error="bookingForm.errors.final_cost_driver"
            />
          </div>
        </v-flex>
        <v-flex pt-1 pl-2 v-if="bookingIsCompletedOrCancelled">
          <v-btn @click="updateFinalCosts" small class="text-none">Update Costs</v-btn>
          <p></p>
        </v-flex>
        <v-flex shrink>
          <EstimatedCost :bookingForm="bookingForm" />
        </v-flex>
      </v-layout>
    </v-layout>
    <v-dialog persistent v-model="addingCard" min-width="100%" max-width="600">
      <v-card>
        <v-card-actions>
          <v-layout row justify-space-between>
            <v-card-title class="headline" style="font-weight: 600;">Add Card</v-card-title>
            <v-btn icon flat="flat" @click="addingCard = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-actions>
        <CardInput :bookingForm="bookingForm" @gotCard="changePaymentTypeToCardWithToken" />
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="addingPromocode" min-width="100%" max-width="600">
      <v-card>
        <v-card-actions>
          <v-layout row justify-space-between>
            <v-card-title class="headline" style="font-weight: 600;">Add Promocode</v-card-title>
            <v-btn icon flat="flat" @click="addingPromocode = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
        </v-card-actions>
        <PromocodeInput :bookingForm="bookingForm" @addedPromocode="changePromocode" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BookingDateInput from "@/components/widget/input/BookingDateInput.vue";
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";
import SimpleNumberInput from "@/components/widget/input/SimpleNumberInput.vue";
import SelectableInput from "@/components/widget/input/SelectableInput.vue";
import SelectablePaymentTypeInput from "@/components/widget/input/SelectablePaymentTypeInput.vue";
import SelectablePromocodeInput from "@/components/widget/input/SelectablePromocodeInput.vue";
import SelectableCardInput from "@/components/widget/input/SelectableCardInput.vue";
import SimpleCurrencyInput from "@/components/widget/input/SimpleCurrencyInput.vue";

import CardInput from "@/components/widget/input/CardInput.vue";
import PromocodeInput from "@/components/widget/input/PromocodeInput.vue";

import EstimatedCost from "@/components/widget/input/EstimatedCost.vue";

export default {
  name: "PaymentInput",
  model: {
    prop: "content",
    event: "input"
  },
  components: {
    BookingDateInput,
    EstimatedCost,
    SimpleTextInput,
    SelectableInput,
    SelectablePaymentTypeInput,
    SelectablePromocodeInput,
    SimpleNumberInput,
    SimpleCurrencyInput,
    SelectableCardInput,
    CardInput,
    PromocodeInput
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    errorMessages: Object,
    bookingForm: Object,
    hideAdditionalCharge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      addingCard: false,
      addingPromocode: false
    };
  },
  computed: {
    bookingIsNotBooked() {
      return this.bookingForm.booking.state == null;
    },
    bookingIsCancelled() {
      return this.bookingForm.booking.state == "cancelled";
    },
    bookingIsCompletedOrCancelled() {
      return (
        this.bookingForm.booking.state == "completed" ||
        this.bookingForm.booking.state == "cancelled"
      );
    }
  },
  methods: {
    finalCostChanged: function(finalCost) {
      console.log("changed " + finalCost);

      this.bookingForm.booking.final_cost = finalCost;

      if (finalCost != null) {
        this.bookingForm.booking.fixed_cost = true;
        this.bookingForm.booking.fixedCostType = this.bookingForm.FIXED_COST_DISPATCHER();
      } else {
        this.bookingForm.booking.fixed_cost = false;
        this.bookingForm.booking.fixedCostType = null;

        this.bookingForm.booking.final_cost_driver = null;
        this.bookingForm.booking.fixed_cost_driver = false;
        this.bookingForm.booking.fixedCostDriverType = null;
      }
    },
    finalCostDriverChanged: function(finalCost) {
      console.log("changed " + finalCost);

      this.bookingForm.booking.final_cost_driver = finalCost;

      if (finalCost != null) {
        this.bookingForm.booking.fixed_cost_driver = true;
        this.bookingForm.booking.fixedCostDriverType = this.bookingForm.FIXED_COST_DISPATCHER();
      } else {
        this.bookingForm.booking.fixed_cost_driver = false;
        this.bookingForm.booking.fixedCostDriverType = null;
      }
    },
    updateFinalCosts: function() {
      this.$emit("updateFinalCosts", null);
    },
    changePaymentTypeToCard: function(card) {
      console.log("CHANGE PAYMENT TYPE TO CARD");
      this.bookingForm.changePaymentType("card", card);
    },
    changePaymentType: function(paymentType) {
      this.bookingForm.changePaymentType(paymentType, null);
    },
    changePromocode: function(promocode) {
      this.bookingForm.changePromocode(promocode);
    },
    changeAdditionalCharge: function(additionalCharge) {
      this.bookingForm.additional_charge = additionalCharge;
      this.bookingForm.getCostEstimate();
    },
    changeFinalCost: function(finalCost) {
      this.bookingForm.booking.final_cost = finalCost;
      this.bookingForm.booking.fixedCostType = this.bookingForm.FIXED_COST_DISPATCHER();
    },
    changeFinalCostDriver: function(finalCostDriver) {
      this.bookingForm.booking.final_cost_driver = finalCostDriver;
      this.bookingForm.booking.fixedCostDriverType = this.bookingForm.FIXED_COST_DISPATCHER();
    },
    changePaymentTypeToCardWithToken(token) {
      this.addingCard = false;
      this.bookingForm.changePaymentType("card", token.card.id);
    },
    changePromocode(promocode) {
      this.addingPromocode = false;
      this.bookingForm.changePromocode(promocode);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.disabled-panel {
  pointer-events: none;
}

.enabled-panel {
  pointer-events: auto;
}

.change-cost-panel {
  padding: 8px;
  background-color: #e3f2fd;
}

.compact-form {
  transform: scale(0.875);
  transform-origin: left;
}

.small-fab {
  transform: scale(0.7);
  transform-origin: bottom;
}

.small-fab button {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
</style>
